import { call, put } from 'redux-saga/effects';
import UploadFileActions from '../redux/UploadFileRedux';
import { api } from './api';


export function* uploadfilesagas(action: any): Generator<any, void, any> {
  const { leave_id, children_id, files } = action;
  const response = yield call(api.uploadFile, leave_id, children_id, files);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(UploadFileActions.uploadFileSuccess(response.data));
  } else {
    yield put(UploadFileActions.uploadFileFailure());
  }
}